<template>
    <div class="coffee-filter-wrapper" v-click-outside="close">
        <div class="filter-main-btn" @click="open = !open" :class="{'shadowed': open}">
            <span v-if="open" class="open-close-icon">-</span>
            <span v-else class="open-close-icon">+</span>
            Filter
        </div>

        <transition-expand>
            <div v-if="open" class="filter-btn-list" :class="{'shadowed': open}">
                <div v-for="(params, categoryName) in filterParams" v-if="params && params.length">
                    <div class="category-btn" @click="selectCategory(categoryName)">
                        <span v-if="selectedCategory === categoryName">-</span>
                        <span v-else>+</span>
                        {{ humanizeCategoryName(categoryName) }}
                    </div>
                    <transition-expand>
                        <div v-if="selectedCategory === categoryName && categoryName !== 'country' && categoryName !== 'size'" class="param-btn-list">
                            <div v-for="param in params" @click="addRemoveParam(categoryName, param)"  class="param-btn" :class="{ 'active-param-btn': isParamAdded(categoryName, param) }">
                                <div v-if="names(param) == 'Other'">
                                    <span>{{ humanizeString("other", true) }}</span>
                                </div>
                                <div v-else>
                                    <span>{{ humanizeString(param.value, true) }}</span>    
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedCategory === categoryName && categoryName === 'country'" class="param-btn-list-size">
                            <div class="added-param-pill-list">
                                    <template v-if="categoryName === 'country' ||
                                    categoryName === 'sub_region'" v-for="(params, categoryName) in addedParams">
                                <div v-for="param in params" @click="removeParam(categoryName, param)" class="added-param-pill">
                                    <span v-if="names(param) == 'Other'">{{ humanizeString("other", true) }}</span>
                                    <span v-else>{{ humanizeString(param.value, true) }}</span>
                                    <span class="remove-option-icon">x</span>
                                </div>
                                    </template>
                                <div v-if="countrySubRegionParamsAdded()" @click="removeCountrySubregion()" class="clear-pill">
                                    Clear All
                                </div>
                            </div>
                              <div>
                                <select style="width: 200px;" v-model="selectedCountry" @change="addRemoveParam(categoryName, selectedCountry); removeSubRegionParam()">
                                     <option value="" disabled>Select Country</option>
                                    <option v-for="param in params" :key="param.key" :value="param">
                                        {{ param.value }}
                                    </option>
                                </select>
                               </div>
                               <div>
                                <select style="width: 200px;" v-if="selectedCountry" v-model="selectedSubregion" @change="addRemoveParam(subRegion, selectedSubregion)" >
                                    <option value="" disabled>Select Sub-Region</option>
                                    <option v-for="sub_region in selectedCountry.sub_regions" :key="sub_region.key" :value="sub_region">{{ sub_region.value }}
                                    </option>
                                </select>
                               </div>
                        </div>
                        <div v-if="selectedCategory === categoryName && categoryName === 'size'" class="param-btn-list-size">
                            <div class="added-param-pill-list">
                                <template v-if="categoryName === 'category' ||
                                    categoryName === 'size_imperial'" v-for="(params, categoryName) in addedParams">
                                <div v-for="param in params" @click="removeParam(categoryName, param)" class="added-param-pill">
                                    <span>{{ humanizeString(param.value, true) }}</span>
                                    <span class="remove-option-icon">x</span>
                                </div>
                                    </template>
                                <div v-if="sizeWeightParamsAdded()" @click="removeSizeWeight()" class="clear-pill">
                                    Clear All
                                </div>
                            </div>
                              <div>
                                <select style="width: 200px;" v-model="selectedSize" @change="addRemoveParam(categorySelect, selectedSize)">
                                     <option value="" disabled>Select Size Category</option>
                                    <option v-for="param in params" :key="param.key" :value="param">
                                        {{ param.value }}
                                    </option>
                                </select>
                              </div>
                              <div>
                                <select style="width: 200px;" v-if="selectedSize" v-model="selectedWeight" @change="addRemoveParam(selectWeight, selectedWeight)">
                                    <option value="" disabled>Select Weight</option>
                                    <option v-for="weight in selectedSize.weights" key="weight.key" :value="weight">
                                     {{ weight.value }}
                                    </option>
                                </select>
                              </div>
                        </div>
                    </transition-expand>
                </div>
            </div>
        </transition-expand>

        <div class="added-param-pill-list">
            <template v-if="showAllFilters">
                <template v-for="(params, categoryName) in addedParams">
                    <div v-for="param in params" @click="removeParam(categoryName, param)" class="added-param-pill">
                        <span v-if="names(param) == 'Other'">{{ humanizeString("other", true) }}</span>
                        <span v-else>{{ humanizeString(param.value, true) }}</span>  
                        <span class="remove-option-icon">x</span>
                    </div>
                </template>
                <div class="clear-pill" v-if="shouldShowToggleButton" @click="toggleFilterSelections">
                  {{ showAllFilters ? 'Show Less' : 'Show All' }}
                </div>
                <div v-if="anyParamsAdded()" @click="removeAll()" class="clear-pill">
                    Clear All
                </div>
            </template>
            <template v-else>
                <template v-for="(params, categoryName) in selectedOptions">
                    <div v-for="param in params" class="added-param-pill" @click="removeParam(categoryName, param)">
                        <span v-if="names(param) == 'Other'">{{ humanizeString("other", true) }}</span>
                        <span v-else>{{ humanizeString(param.value, true) }}</span>  
                        <span class="remove-option-icon">x</span>
                    </div>
                </template>
                <!-- Toggle button to show/hide the expanded filter selections -->
                <div class="clear-pill" v-if="shouldShowToggleButton" @click="toggleFilterSelections">
                  {{ showAllFilters ? 'Show Less' : 'Show All' }}
                </div>
                <div v-if="anyParamsAdded()" @click="removeAll()" class="clear-pill">
                    Clear All
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { ClickOutside } from '../../directives/click-outside';
    import CommonMixin from '../../mixins/common-mixin';
    import TransitionExpand from '../transition-expand';

    export default {
        name: "coffee-filter",
        directives: {ClickOutside},
        mixins: [CommonMixin],
        components: {
            TransitionExpand
        },
        props: {
            filterParams: Object,
            presetFilterParams: Array
        },
        data: function () {
            return {
                open: false,
                selectedCategory: undefined,
                selectedCountry: "",
                selectedSubregion: "",
                addedParams: {},
                name: undefined,
                selectedSize: "",
                selectedWeight: "",
                subRegion: 'sub_region',
                selectWeight: 'size_imperial',
                categorySelect: 'category',
                selectedOptions: {},
                showAllFilters: false,
                toggleLimit: 10
            }
        },
        computed: {
            shouldShowToggleButton() {
                return this.getValuesCount() > this.toggleLimit;
            }
        },
        methods: {
            getValuesCount() {
              // Use Object.values() to extract the values of the nested object
              const values = Object.values(this.addedParams);

              // Use reduce() to count the total number of values in each nested array
              const totalValues = values.reduce((count, array) => count + array.length, 0);

              return totalValues;
            },
            toggleFilterSelections() {
                this.showAllFilters = !this.showAllFilters;
            },
            close() {
                this.open = false;
            },
            selectCategory(newCategory) {
                if (this.selectedCategory === newCategory) {
                    this.selectedCategory = undefined;
                } else {
                    this.selectedCategory = newCategory
                }
            },
            addRemoveParam(category, param) {
                this.isParamAdded(category, param) ?
                    this.removeParam(category, param) : this.addParam(category, param);
            },
            addParam(category, param) {
                if (category === "price"){
                    this.addedParams[category] = [];
                    this.addedParams[category].push(param);
                    if(this.toggleLimit >= this.getValuesCount()){
                        this.selectedOptions[category] = [];
                        this.selectedOptions[category].push(param);
                    }
                }
                else{
                    this.addedParams[category].push(param);
                    if(this.toggleLimit >= this.getValuesCount()){
                        this.selectedOptions[category].push(param);
                    }
                }
                this.paramsUpdated();
            },
            removeParam(category, param) {
                if (category === "country"){
                    this.selectedCountry = "";
                } else if (category === "sub_region"){
                    this.selectedSubregion = "";
                } else if (category === "category"){
                    this.selectedSize = "";
                } else if (category === "size_imperial"){
                    this.selectedWeight = "";
                }

                this.addedParams[category] = this.addedParams[category].filter(p => p.key !== param.key);
                this.selectedOptions[category] = this.selectedOptions[category].filter(p => p.key !== param.key);
                this.paramsUpdated();
            },
            paramsUpdated() {
                // HACK: This is to trigger Vue change detection
                this.addedParams = Object.assign({}, this.addedParams);

                // Take keys from the addedParams array
                const outputParams = Object.assign({}, this.addedParams);
                Object.keys(outputParams).forEach( key =>
                    outputParams[key] = outputParams[key].map(p => p.key)
                );

                this.$emit('paramsUpdated', outputParams, this.anyParamsAdded());
            },
            isParamAdded(category, param) {
                return !!this.addedParams[category].find(p => p.key === param.key);
            },
            anyParamsAdded() {
                for (let key in this.addedParams) {
                    if (this.addedParams.hasOwnProperty(key) && this.addedParams[key].length) {
                        return true;
                    }
                }
                return false;
            },
            countrySubRegionParamsAdded() {
                for (let key in this.addedParams) {
                    if ((key === 'country' || key === 'sub_region') && this.addedParams.hasOwnProperty(key) && this.addedParams[key].length) {
                        return true;
                    }
                }
                return false;
            },
            sizeWeightParamsAdded() {
                for (let key in this.addedParams) {
                    if ((key === 'category' || key === 'size_imperial') && this.addedParams.hasOwnProperty(key) && this.addedParams[key].length) {
                        return true;
                    }
                }
                return false;
            },
            names(param){
                if (param.value.split(" ")[0] == "Other"){
                    return "Other";
                }
            },
            removeAll() {
                for (let key in this.addedParams) {
                    if (this.addedParams.hasOwnProperty(key)) {
                        this.addedParams[key] = [];
                    }
                    if (this.selectedOptions.hasOwnProperty(key)) {
                        this.selectedOptions[key] = [];
                    }
                }
                this.selectedCountry = "";
                this.selectedSubregion = "";
                this.selectedSize = "";
                this.selectedWeight = "";
                this.paramsUpdated();
            },
            removeCountrySubregion(){
                this.selectedCountry = "";
                this.selectedSubregion = "";
                if (this.addedParams.hasOwnProperty('country')) {
                    this.addedParams['country'] = [];
                }
                if (this.addedParams.hasOwnProperty('sub_region')) {
                    this.addedParams['sub_region'] = [];
                }
                if (this.selectedOptions.hasOwnProperty('country')) {
                    this.selectedOptions['country'] = [];
                }
                if (this.selectedOptions.hasOwnProperty('sub_region')) {
                    this.selectedOptions['sub_region'] = [];
                }
                this.paramsUpdated();
            },
            removeSubRegionParam(){
                this.selectedSubregion = "";
                if (this.addedParams.hasOwnProperty('sub_region')) {
                    this.addedParams['sub_region'] = [];
                }
                if (this.selectedOptions.hasOwnProperty('sub_region')) {
                    this.selectedOptions['sub_region'] = [];
                }              
                this.paramsUpdated();
            },
            removeSizeWeight(){
                this.selectedSize = "";
                this.selectedWeight = "";
                if (this.addedParams.hasOwnProperty('category')) {
                    this.addedParams['category'] = [];
                }
                if (this.addedParams.hasOwnProperty('size_imperial')) {
                    this.addedParams['size_imperial'] = [];
                }
                if (this.selectedOptions.hasOwnProperty('category')) {
                    this.selectedOptions['category'] = [];
                }
                if (this.selectedOptions.hasOwnProperty('size_imperial')) {
                    this.selectedOptions['size_imperial'] = [];
                }
                this.paramsUpdated();
            },
            humanizeCategoryName(categoryName) {
                switch (categoryName) {
                    case 'rating':
                        return 'My Ratings'
                }
                return this.humanizeString(categoryName, true)
            }
        },
        mounted: function () {
            Object.keys(this.filterParams).forEach(key => {
                this.selectedOptions[key] = [];
                this.addedParams[key] = [];
            });
            this.addedParams['category'] = [];
            this.addedParams['size_imperial'] = [];
            this.addedParams['sub_region'] = [];
            this.selectedOptions['category'] = [];
            this.selectedOptions['size_imperial'] = [];
            this.selectedOptions['sub_region'] = [];
        },
        watch: {
            presetFilterParams: function () {
                if (this.presetFilterParams.includes('5lb')) {
                    if (!this.addedParams || !this.addedParams.size ) {
                        return;
                    }

                    let alreadyIncluded5lb = false;
                    this.addedParams.size.forEach(p => alreadyIncluded5lb = p.key === '5lb');

                    if (alreadyIncluded5lb) {
                        return;
                    }

                    this.addedParams.size.push(
                        {
                            key: "5lb",
                            value: "5lb"
                        }
                    );
                    this.paramsUpdated();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    $space-size: 0.5rem;
    $white: #F4F7F1;
    $black: #18262D;
    $red: #e15f60;
    $pink: #FFD0D1;
    $shadow: 0 1px 3px -1px rgba(0,0,0,0.75);
    $max-tablet-width: 768px;

    .coffee-filter-wrapper {
        position: relative;
    }
    .filter-main-btn {
        padding: 0.75rem 1.5rem;
        background-color: $red;
        color: white;
        cursor: pointer;
        &:hover {
            background-color: darken($red, 5%);
        }
    }
    .open-close-icon {
        margin-right: 8px;
    }
    .filter-btn-list {
        overflow: hidden;
        position: absolute;
        left: 0;
        width: 100%;
        z-index: 1;
        background-color: $white;
        box-shadow: $shadow;
    }
    .filter-btn-list {
        max-height: calc(100vh - 206px);
        overflow: auto !important;
    }
    .shadowed {
        -webkit-box-shadow: $shadow;
        -moz-box-shadow: $shadow;
        box-shadow: $shadow;
    }
    .category-btn {
        margin-top: $space-size;
        padding: 1rem 1.5rem;
        color: $black;
        background-color: $pink;
        cursor: pointer;
        &:hover {
            background-color: darken($pink, 5%);
        }
    }
    .param-btn-list {
        display: grid;
        grid-template-columns: 50% auto;
        grid-gap: $space-size;
        padding: 0.6rem;
        margin-bottom: 0.5rem;
        max-height: 30vh;
        overflow-y: scroll;
    }
    .param-btn-list-size{
        display: flex;
        grid-template-columns: 100%;
        grid-gap: $space-size;
        padding: 0.6rem;
        margin-bottom: 0.5rem;
        max-height: 30vh;
        flex-wrap: wrap;
        overflow-y: auto;
        .param-btn{
            padding: 1rem;
        }
        .param-btn-size{
            border-color: #8FA7A3;
            color: #72918c;
        }
        select {
            flex: 1;
            display: block;
            width: 100%;
        }
    }
    .bag-category{
        display: block;
        margin-bottom: 5px;
    }

    .param-btn {
        display: inline-grid;
        align-items: center;
        padding: $space-size;
        font-size: 1rem;
        text-align: center;
        color: $red;
        border: solid 1px $red;
        cursor: pointer;
        span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        &:hover {
            color: darken($red, 20%);
            border-color: darken($red, 20%);
        }
    }
    .param-btn-size {
        display: inline-grid;
        align-items: center;
        padding: $space-size;
        font-size: 1rem;
        text-align: center;
        color: $red;
        border: solid 1px $red;
        cursor: pointer;
        span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        &:hover {
            color: darken($red, 20%);
            border-color: darken($red, 20%);
        }
    }
    .bag-size{
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        .param-btn-size{
            flex: 1 0 0%;
            min-width: 20%;
        }
    }
    .active-param-btn {
        color: white;
        background-color: $red;
    }
    .added-param-pill-list {
        display: flex;
        flex-wrap: wrap;
        flex: 0 0 100%;
        max-width: 100%;
    }
    .pill {
        margin: 6px 4px 0 0;
        padding: 1px 0.5rem;
        font-size: 12px;
        white-space: nowrap;
        cursor: pointer;
    }
    .added-param-pill {
        @extend .pill;
        background-color: $red;
        &:hover {
            background-color: lighten($red, 10%);
        }
    }
    .clear-pill {
        @extend .pill;
        background-color: $white;
        color: $red;
        border: 1px solid $red;
        &:hover {
            color: darken($red, 20%);
            border-color: darken($red, 20%);
        }
    }
    .remove-option-icon {
        float: right;
        padding-left: 0.5rem;
    }

    @media only screen and (max-width: $max-tablet-width) {
        .filter-btn-list {
            width: 100vw;
            margin-left: -200%;
        }
        .added-param-pill-list {
            padding: 0 0.5rem;
        }
        .pill {
            max-width: 80px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        .param-btn-list {
            width: 100% !important;
            position: static !important;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
        }
        .param-btn {
            width: 45%;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-bottom: 0.5rem;
            padding: 0.5rem 0;
        }
    }
</style>